import base from "./base.service";

const authorizedInstance = base.service(true);
const unauthorizedInstance = base.service(false);

export const createTiming = (timing) => {
  return authorizedInstance.post(`/Timing/create-timing`, timing);
};
export const getAllByPlayroomId = (playroomId) => {
  return authorizedInstance.get(`/Timing/get-by-playroom/${playroomId}`);
};
export const deleteTimingById = (id) => {
  return authorizedInstance.delete(`/Timing/delete-timing/${id}`);
};

const timingService = {
  createTiming,
  getAllByPlayroomId,
  deleteTimingById,
};

export default timingService;
